// utils/client.js
export const getClientInfo = () => ({
  userAgent: navigator.userAgent,
  lang: navigator.language,
  referer: document.referrer || '',
  // Az IP-t a backend úgyis a req.ip-ből szedi ki
});